import type { AppProps } from 'next/app';
import Script from 'next/script';

import { PulseToGtmSync } from 'shared/pulse';

import 'uno.css';

import '../styles/app.css';
import { ExperimentProvider } from '@/hooks/experiments';

declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

type FrontpageAppProps = AppProps<{
    experiments?: Record<string, string>;
}>;

const FrontpageApp = ({ Component, pageProps }: FrontpageAppProps) => (
    <>
        <ExperimentProvider experiments={pageProps.experiments}>
            <Component {...pageProps} />
        </ExperimentProvider>
        <Script
            src="https://cdn.trackjs.com/agent/v3/latest/t.js"
            onLoad={() => {
                window.TrackJS?.install?.({
                    token: '74bb3e28a1604fd2b28c72c568722d21',
                    application: 'finn-travel-frontpage',
                    version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                    enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                });
            }}
            crossOrigin=""
        />
        <PulseToGtmSync />
    </>
);

export default FrontpageApp;
